import { GetFormPrice } from "./getFormPrice.js";
/**
 * Remember to update this function in the aggregation schema
 * @param provider
 * @param context
 * @returns
 */
export const provideValue = (provider, context) => {
    var _a;
    if (typeof provider === "object") {
        switch (provider.type) {
            case "constant":
                return (_a = provider.value) !== null && _a !== void 0 ? _a : 0;
            case "revert-provider":
                return -provideValue(provider.value, context);
            case "sum-provider":
                return provider.values.reduce((acc, p) => acc + provideValue(p, context), 0);
            case "condition-provider":
                const testedValue = provideValue(provider.testedValue, context);
                const greaterValue = provideValue(provider.greaterThan, context);
                if (testedValue > greaterValue) {
                    return provideValue(provider.whenTrue, context);
                }
                else {
                    return provideValue(provider.whenFalse, context);
                }
            case "count-provider":
                return context.orderedFormats.find((format) => format.name === provider.formatName).count;
            case "price-provider":
                const format = context.orderedFormats.find((f) => f.name === provider.formatName);
                return provideValue(format.pricePerItem, context) * format.count;
            case "all-orderd-image-formats-sum-provider":
                const countSum = context.imageOrdersExcludedCurrentFormat.reduce((acc, item) => acc + item.formats.reduce((a, c) => a + c.count, 0), 0);
                return countSum;
            case "per-item":
                return context.quantity * provideValue(provider.value, context);
            case "multiply-provider":
                return (provideValue(provider.value1, context) *
                    provideValue(provider.value2, context));
            case "per-item-tiers-provider":
                let price = 0;
                let countLeft = context.quantity;
                for (const tier of provider.tiers) {
                    const currCount = Math.min(countLeft, tier.next);
                    price += provideValue(tier.price, context) * currCount;
                    countLeft -= currCount;
                    if (countLeft === 0)
                        break;
                }
                price += provideValue(provider.priceForAllNext, context) * countLeft;
                return price;
            default:
                throw new Error("Invalid Int price provider");
        }
    }
    else {
        return provider;
    }
};
export const providePriceForFormat = (provider, context) => {
    if (typeof provider === "number") {
        const format = context.orderedFormats.find((o) => o.name === context.currentFormatName);
        return format.count * provider;
    }
    return provideValue(provider, context);
};
export const providePriceForExtraOffer = (orderedOffer) => {
    var _a, _b;
    return providePriceForFormat(orderedOffer.price, {
        currentFormatName: "default",
        imageOrdersExcludedCurrentFormat: [],
        quantity: (_a = orderedOffer.count) !== null && _a !== void 0 ? _a : 1,
        orderedFormats: [
            {
                name: "default",
                pricePerItem: orderedOffer.price,
                count: (_b = orderedOffer.count) !== null && _b !== void 0 ? _b : 1,
            },
        ],
    });
};
/**
 * It is used to return orders of one of the image with specific format excluded usefull when using `provideValue`
 * @param orders
 * @param imageIndexToInclude
 * @param offerIndex
 * @param formatNameToExclude
 * @returns
 */
export const provideImageOrdersExcludedCurrentFormat = (orders, imageIndexToInclude, offerIndex, formatNameToExclude) => {
    return orders
        .filter((o) => o.imageIndex.toString() === imageIndexToInclude.toString())
        .map((o) => ({
        //we are filtering formats only if the order is exactly the same
        formats: o.offerIndex === offerIndex ?
            o.orderedFormats.filter((f, i) => f.name !== formatNameToExclude)
            : o.orderedFormats,
    }));
};
export const getFormatsAndExtraOfferPriceSum = (order, components) => {
    var _a;
    const { orders, oneTimeOrders, flowFormInputs } = order;
    return (GetFormPrice(flowFormInputs, components) +
        orders.reduce((acc, img) => acc +
            img.orderedFormats.reduce((acc, format) => acc +
                providePriceForFormat(format.pricePerItem, {
                    currentFormatName: format.name,
                    quantity: format.count,
                    orderedFormats: img.orderedFormats,
                    imageOrdersExcludedCurrentFormat: provideImageOrdersExcludedCurrentFormat(order.orders, img.imageIndex, img.offerIndex, format.name),
                }), 0), 0) +
        ((_a = oneTimeOrders === null || oneTimeOrders === void 0 ? void 0 : oneTimeOrders.reduce((acc, orderedOffer) => {
            var _a, _b;
            return acc +
                providePriceForFormat(orderedOffer.price, {
                    currentFormatName: "default",
                    imageOrdersExcludedCurrentFormat: [],
                    quantity: (_a = orderedOffer.count) !== null && _a !== void 0 ? _a : 1,
                    orderedFormats: [
                        {
                            name: "default",
                            pricePerItem: orderedOffer.price,
                            count: (_b = orderedOffer.count) !== null && _b !== void 0 ? _b : 1,
                        },
                    ],
                });
        }, 0)) !== null && _a !== void 0 ? _a : 0));
};
